import { Add } from "@mui/icons-material";
import {
  Button,
  Stack,
  Typography,
  alpha,
  useMediaQuery,
  useTheme,
} from "@mui/material";

interface IProps {
  onClick: Function;
}

export function AddDependent({ onClick }: IProps) {
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Stack spacing={1.5} sx={{ pt: isMobileLayout ? 0.5 : 1 }}>
      <Button
        fullWidth={isMobileLayout}
        variant={isMobileLayout ? "outlined" : "text"}
        startIcon={<Add />}
        onClick={() => onClick()}
        sx={{
          width: isMobileLayout ? "100%" : "fit-content",
          justifyContent: isMobileLayout ? "flex-start" : undefined,
          borderRadius: isMobileLayout ? 2.5 : 1,
          py: isMobileLayout ? 1.35 : 1,
          px: isMobileLayout ? 2 : 1,
          textTransform: "none",
          fontWeight: 700,
          color: "primary.main",
          borderColor: isMobileLayout
            ? alpha(theme.palette.primary.main, 0.35)
            : undefined,
          borderStyle: isMobileLayout ? "dashed" : undefined,
          bgcolor: isMobileLayout
            ? alpha(theme.palette.primary.main, 0.04)
            : undefined,
          "&:hover": {
            bgcolor: alpha(theme.palette.primary.main, 0.08),
            borderColor: theme.palette.primary.main,
          },
        }}
      >
        <Typography variant="body2" fontWeight={700}>
          Adicionar dependente
        </Typography>
      </Button>
    </Stack>
  );
}
